import { render, staticRenderFns } from "./FileSizeForm.vue?vue&type=template&id=aca06220&"
import script from "./FileSizeForm.vue?vue&type=script&lang=js&"
export * from "./FileSizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports